package io.horion.auth.di

import io.horion.auth.presentation.viewmodel.AuthViewModel
import org.koin.dsl.module

@Suppress("UNREACHABLE_CODE")
val viewModelModule = module {
    single { AuthViewModel(get(),get()) }
}